import { render, staticRenderFns } from "./catalogoexames.vue?vue&type=template&id=625aa746&"
import script from "./catalogoexames.vue?vue&type=script&lang=js&"
export * from "./catalogoexames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports